<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'App'
	}
</script>

<style>
@import "./assets/libs/tobii/css/tobii.min.css";
@import "./assets/libs/@mdi/font/css/materialdesignicons.min.css";
</style>